module.exports = __webpack_public_path__ + "img/cert230.ce3139f0.jpg";